/** @namespace Bodypwa/Util/Dom/Element/addElementToHead */
export const addElementToHead = (element, id, innerHtml, type = '') => {
    if (!document.getElementById(id)) {
        const el = document.createElement(element);
        if (type) {
            el.type = type;
        }
        el.id = id;
        el.innerHTML = innerHtml;
        document.head.appendChild(el);
    }
};

/** @namespace Bodypwa/Util/Dom/Element/replaceAll */
export const replaceAll = (str, mapObj) => {
    const re = new RegExp(Object.keys(mapObj).join('|'), 'g');
    return str.replace(re, (matched) => mapObj[matched]);
};
